import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ImmomioButtonComponent } from '@immomio/ui/button';
import { WhitelabelImageWebComponent } from '../whitelabel-image/whitelabel-image.component';
import { WhitelabelImage, WhitelabelImageAltTag } from '@resident-nx/shared';

@Component({
  selector: 'rs-web-file-requested-info',
  imports: [TranslateModule, ImmomioButtonComponent, WhitelabelImageWebComponent],
  templateUrl: './file-requested-info.component.html',
  styleUrl: './file-requested-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FileRequestedInfoComponent {
  protected readonly WhitelabelImage = WhitelabelImage;
  protected readonly WhitelabelImageAltTag = WhitelabelImageAltTag;

  isRequested = input<boolean>();
  isAlreadyRequested = input<boolean>();
  isUnavailable = input<boolean>();

  backToOverview = output();
}
